// extracted by mini-css-extract-plugin
export default {"container":"style_container__IFK1T","further":"style_further__apx-A"};